import {useEffect, useRef, useState} from 'react'
import {createPlugin} from '@/components/MindMap/index.mjs'
import {publish, subscribe, unsubscribe} from '@/script/event.mjs'

export default () => {
    const refIsHidden = useRef(false)

    const extensions = () => ({
        hide() {
            const walkArs = node => {
                const {rev: referredRev} = node.data

                for (const ar of node.children) {
                    ar.isHidden = true
                    const {arName: ver} = ar.data
                    const rev = Number(ver.replace(/^\d+\.(\d+)$/g, '$1'))

                    if (rev < referredRev) {
                        for (const nn of ar.chain) {
                            nn.isHidden = false
                        }
                    }

                    walkRefs(ar)
                }
            }

            const walkRefs = node => {
                for (const n of node.children) {
                    walkArs(n)
                }
            }

            walkArs(this.root)
            refIsHidden.current = true
            publish(this, 'irrelevant-is-hidden-change', true)
        },

        show() {
            for (const n of this.dfs(this.root.children)) {
                n.isHidden = false
            }

            refIsHidden.current = false
            publish(this, 'irrelevant-is-hidden-change', false)
        },

        useIsHidden() {
            const [isHidden, setIsHidden] = useState(refIsHidden.current)

            useEffect(
                () => {
                    subscribe(this, 'irrelevant-is-hidden-change', setIsHidden)

                    return () => {
                        unsubscribe(
                            this, 'irrelevant-is-hidden-change', setIsHidden
                        )
                    }
                },

                []
            )

            return isHidden
        },
    })

    return createPlugin('irrelevant', {extensions})
}
